import { doctorHealthHistoryBanner } from "@/assets/images";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { v4 as uuid } from "uuid";
import { Button } from "@/pages/quiz/15000/components/Button";

const DoctorHealthHistoryBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const onSubmit = () => {
    window.dataLayer.push({
      eventId: uuid(),
      event: "medical_history_start",
    });
    setQuestionAnswer(true);
  };

  return (
    <>
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        Next, let's go through your health history.
      </p>

      <img
        src={doctorHealthHistoryBanner}
        className="mx-auto"
        alt="Health History"
      />

      <Button onClick={onSubmit} />
    </>
  );
};

export { DoctorHealthHistoryBanner };
